import { createAction } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { push } from '@mews/routing';
import { setShouldRestoreScroll } from '@mews-commander/ui';
import { MESSAGE_CENTER_OPENED, MESSAGE_CENTER_CLOSED, THREAD_REMOVED } from '../actionTypes';
import { popHistory, setNavigatedBack } from '../../../core/history';

export const openMessageCenter = () => createAction(MESSAGE_CENTER_OPENED);
export const closeMessageCenter = () => createAction(MESSAGE_CENTER_CLOSED);

export const removeThread = (threadId: string) => createAction(THREAD_REMOVED, { id: threadId });

export const handleCloseAction = (): CommanderThunkAction => (dispatch) => {
    const url = popHistory();
    setNavigatedBack(true);
    dispatch(push(url));
    setShouldRestoreScroll(true);
};
